/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  LoadingDialog,
} from "../../_metronic/_partials/controls";
import ReactSelect from "react-select";
import SVG from "react-inlinesvg";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import paginationFactory from "react-bootstrap-table2-paginator";
import { sortCaret, toAbsoluteUrl } from "../../_metronic/_helpers";
import { Helmet } from "react-helmet";
import {
  ExportAs,
  formatPhoneNumber,
  translateAuto,
} from "../../_metronic/_helpers/AtHelper";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, Modal, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import Swal from "sweetalert2";
import { DropdownCustomToggler } from "../../_metronic/_partials/dropdowns";

const adapter = new LocalStorage("db");
const db = low(adapter);

const TruckerTypeOptions = [
  { label: "Carriers Driver", value: "Carriers Driver" },
  { label: "Carrier Owner", value: "Carrier Owner" },
  { label: "Power Only Carrier", value: "Power Only Carrier" },
  { label: "Canada-Based Carrier", value: "Canada-Based Carrier" },
  { label: "Mexico-Based Carrier", value: "Mexico-Based Carrier" },
];
export default function MyTruckersList() {
  const [TruckersList, setTruckersList] = useState([]);
  const [isLoadingAuth, setisLoadingAuth] = useState(false);
  const [initTeamObject, setinitTeamObject] = useState({
    CompanyName: "",
    McNumber: "",
    DotNumber: "",
    Type: "",
    Address: "",
    Address2: "",
    City: "",
    State: "",
    Zipcode: "",
    Country: "",
    Email: "",
    PhoneNumber: "",
    FirstName: "",
    LastName: "",
    Website: "",
  });
  const [showAddTruckerModal, setshowAddTruckerModal] = useState(false);
  const [ContriesViewModel, setContriesViewModel] = useState([]);
  const { t } = useTranslation();
  function GetContriesViewModel() {
    var myHeaders = new Headers();

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Countries`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setContriesViewModel(data);
        }
      })
      .catch((error) => {
        Swal.fire(t("Error"), error);
      });
  }
  function getTruckersData() {
    setisLoadingAuth(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };

    fetch(`${window.$apiurl}/api/Import/GetTruckers`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          setTruckersList(result[1].Truckers || []);
        } else {
          if (
            result[1].ModelState !== null &&
            result[1].ModelState !== undefined &&
            result[1].ModelState !== ""
          ) {
            let modelState = result[1].ModelState;
            if (modelState)
              Object.keys(modelState).forEach(function(k) {
                modelState[k].forEach((element) => {
                  console.log("error", element);
                });
              });
          } else if (
            result[1].Message !== null &&
            result[1].Message !== undefined &&
            result[1].Message !== ""
          ) {
            console.log("error", result[1].Message);
          } else if (
            result[1].error_description !== null &&
            result[1].error_description !== undefined &&
            result[1].error_description !== ""
          ) {
            console.log("error", result[1].error_description);
          } else {
            console.log("error", "Bad request");
          }
        }
        setTimeout(() => {
          setisLoadingAuth(false);
        }, 500);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  useEffect(() => {
    getTruckersData();
    GetContriesViewModel();
  }, []);
  function SaveNewTrucker(parameters) {
    console.log("parameters", parameters);
    try {
      setisLoadingAuth(true);
      return fetch(`${window.$apiurl}/api/Import/PostTrucker`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          Authorization: `bearer ${db.read().getState().Token}`,
          "Content-Type": "application/json",
          Allow: "POST",
        },
        body: JSON.stringify(parameters),
      })
        .then(async (response) => {
          const statusCode = await response.status;
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json().then((data) => [statusCode, data]);
          } else {
            return response
              .text()
              .then((text) => [statusCode, { Message: "" }]);
          }
        })
        .then((result) => {
          if (result[0] === 200) {
            Swal.fire(
              t("Great"),
              t("Trucker_has_been_created_successfully"),
              "success"
            );
            getTruckersData();
            setshowAddTruckerModal(false);
          } else {
            if (
              result[1].ModelState !== null &&
              result[1].ModelState !== undefined &&
              result[1].ModelState !== ""
            ) {
              let modelState = result[1].ModelState;
              if (modelState)
                Object.keys(modelState).forEach(function(k) {
                  modelState[k].forEach((element) => {
                    Swal.fire(
                      translateAuto("Error"),
                      translateAuto(element),
                      "error"
                    );
                  });
                });
            } else if (
              result[1].ExceptionMessage !== null &&
              result[1].ExceptionMessage !== undefined &&
              result[1].ExceptionMessage !== ""
            ) {
              Swal.fire(
                translateAuto("Error"),
                translateAuto(result[1].ExceptionMessage),
                "error"
              );
            } else if (
              result[1].Message !== null &&
              result[1].Message !== undefined &&
              result[1].Message !== ""
            ) {
              Swal.fire(
                translateAuto("Error"),
                translateAuto(result[1].Message),
                "error"
              );
            } else if (
              result[1].error_description !== null &&
              result[1].error_description !== undefined &&
              result[1].error_description !== ""
            ) {
              Swal.fire(
                translateAuto("Error"),
                translateAuto(result[1].error_description),
                "error"
              );
            } else {
              Swal.fire(
                translateAuto("Error"),
                translateAuto("Bad_request"),
                "error"
              );
            }
          }
          setisLoadingAuth(false);
        })
        .catch((error) => {
          Swal.fire(t("Error"), error);
          setisLoadingAuth(false);
        });
    } catch (err) {
      console.log(err);
    }
  }
  function PutTrucker(parameters) {
    console.log("parameters", parameters);
    try {
      setisLoadingAuth(true);
      return fetch(`${window.$apiurl}/api/Import/PutTrucker/${parameters.Id}`, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain, */*",
          Authorization: `bearer ${db.read().getState().Token}`,
          "Content-Type": "application/json",
          Allow: "POST",
        },
        body: JSON.stringify(parameters),
      })
        .then(async (response) => {
          const statusCode = await response.status;
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json().then((data) => [statusCode, data]);
          } else {
            return response
              .text()
              .then((text) => [statusCode, { Message: "" }]);
          }
        })
        .then((result) => {
          if (result[0] === 200) {
            Swal.fire(
              t("Great"),
              t("Trucker_has_been_created_successfully"),
              "success"
            );
            getTruckersData();
            setshowAddTruckerModal(false);

            //history.push("/useractivationemail?");
          } else {
            if (
              result[1].ModelState !== null &&
              result[1].ModelState !== undefined &&
              result[1].ModelState !== ""
            ) {
              let modelState = result[1].ModelState;
              if (modelState)
                Object.keys(modelState).forEach(function(k) {
                  modelState[k].forEach((element) => {
                    Swal.fire(
                      translateAuto("Error"),
                      translateAuto(element),
                      "error"
                    );
                  });
                });
            } else if (
              result[1].Message !== null &&
              result[1].Message !== undefined &&
              result[1].Message !== ""
            ) {
              Swal.fire(
                translateAuto("Error"),
                translateAuto(result[1].Message),
                "error"
              );
            } else if (
              result[1].error_description !== null &&
              result[1].error_description !== undefined &&
              result[1].error_description !== ""
            ) {
              Swal.fire(
                translateAuto("Error"),
                translateAuto(result[1].error_description),
                "error"
              );
            } else {
              Swal.fire(
                translateAuto("Error"),
                translateAuto("Bad_request"),
                "error"
              );
            }
          }
          setisLoadingAuth(false);
        })
        .catch((error) => {
          Swal.fire(t("Error"), error);
          setisLoadingAuth(false);
        });
    } catch (err) {
      console.log(err);
    }
  }
  const columns = [
    {
      dataField: "Name",
      text: t("Name"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Name;
      },
    },
    {
      dataField: "Owner",
      text: t("Owner"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Owner;
      },
    },
    {
      dataField: "Email",
      text: t("Email"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Email;
      },
    },
    {
      dataField: "PhoneNumber",
      text: t("Phone_Number"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return formatPhoneNumber(row.PhoneNumber);
      },
    },
    {
      dataField: "Type",
      text: t("Types"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Type;
      },
    },
    {
      dataField: "Approved",
      text: t("Approved"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Approved === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "Action",
      text: t("Action"),
      sort: true,
      formatter: (cell, row) => {
        return (
          <Dropdown className="dropdown-inline position-unset" alignRight>
            <Dropdown.Toggle
              as={DropdownCustomToggler}
              id="dropdown-toggle-top"
            >
              <i className="ki ki-bold-more-hor" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
              <ul className="navi navi-hover py-5">
                <li className="navi-item">
                  <a
                    href={() => false}
                    onClick={() => {
                      var myHeaders = new Headers();
                      myHeaders.append(
                        "Authorization",
                        `Bearer ${db.read().getState()?.Token}`
                      );

                      var requestOptions = {
                        method: "GET",
                        headers: myHeaders,
                        redirect: "follow",
                      };

                      fetch(
                        `${window.$apiurl}/api/Import/getTrucker/${row.Id}`,
                        requestOptions
                      )
                        .then(async (response) => {
                          const statusCode = await response.status;
                          const contentType = response.headers.get(
                            "content-type"
                          );
                          if (
                            contentType &&
                            contentType.indexOf("application/json") !== -1
                          ) {
                            return response
                              .json()
                              .then((data) => [statusCode, data]);
                          } else {
                            return response
                              .text()
                              .then((text) => [statusCode, { Message: "" }]);
                          }
                        })
                        .then(async (result) => {
                          if (result[0] === 200) {
                            var data = result[1];
                            setinitTeamObject(data);
                            setshowAddTruckerModal(true);
                          }
                        })
                        .catch((error) => {
                          console.log("error", error);
                        });
                    }}
                    className="navi-link"
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary pr-2">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg"
                        )}
                      ></SVG>
                    </span>
                    <span className="navi-text">{t("Edit")}</span>
                  </a>
                </li>
                <li className="navi-item">
                  <a
                    href={() => false}
                    className="navi-link"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure",
                        text: `You won't be able to ${
                          row.Approved ? "Unapprove" : "Approve"
                        } this`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: `Yes ${
                          row.Approved ? "Unapprove" : "Approve"
                        } it`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setisLoadingAuth(true);

                          var myHeaders = new Headers();
                          myHeaders.append(
                            "Authorization",
                            `Bearer ${db.read().getState()?.Token}`
                          );
                          myHeaders.append("Content-Type", "application/json");

                          var requestOptions = {
                            method: "delete",
                            headers: myHeaders,
                            redirect: "follow",
                          };

                          fetch(
                            `${window.$apiurl}/api/Import/DeleteTrucker/${row.Id}`,
                            requestOptions
                          )
                            .then(async (response) => {
                              const statusCode = await response.status;
                              const contentType = response.headers.get(
                                "content-type"
                              );
                              if (
                                contentType &&
                                contentType.indexOf("application/json") !== -1
                              ) {
                                return response
                                  .json()
                                  .then((data) => [statusCode, data]);
                              } else {
                                return response
                                  .text()
                                  .then((text) => [
                                    statusCode,
                                    { Message: "" },
                                  ]);
                              }
                            })
                            .then(async (result) => {
                              if (result[0] === 200) {
                                Swal.fire(
                                  row.Approved ? "Unapproved" : "Approve",
                                  `Trucker has been ${
                                    row.Approved ? "Unapproved" : "Approved"
                                  } successfully`,
                                  "success"
                                );
                                setisLoadingAuth(false);
                                getTruckersData();
                              } else {
                                if (
                                  result[1].ModelState !== null &&
                                  result[1].ModelState !== undefined &&
                                  result[1].ModelState !== ""
                                ) {
                                  let modelState = result[1].ModelState;
                                  if (modelState)
                                    Object.keys(modelState).forEach(function(
                                      k
                                    ) {
                                      modelState[k].forEach((element) => {
                                        Swal.fire(
                                          "Oops!",
                                          translateAuto(element),
                                          "error"
                                        );
                                      });
                                    });
                                } else if (
                                  result[1].Message !== null &&
                                  result[1].Message !== undefined &&
                                  result[1].Message !== ""
                                ) {
                                  Swal.fire(
                                    "Oops!",
                                    translateAuto(result[1].Message),
                                    "error"
                                  );
                                } else if (
                                  result[1].error_description !== null &&
                                  result[1].error_description !== undefined &&
                                  result[1].error_description !== ""
                                ) {
                                  Swal.fire(
                                    "Oops!",
                                    translateAuto(result[1].error_description),
                                    "error"
                                  );
                                } else {
                                  Swal.fire(
                                    "Oops!",
                                    translateAuto("Bad_request"),
                                    "error"
                                  );
                                }
                              }
                              setisLoadingAuth(false);
                            })
                            .catch((error) => {
                              console.log("error", error);
                              setisLoadingAuth(false);
                            });
                        }
                      });
                    }}
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      className={`svg-icon svg-icon-md svg-icon-${
                        row.Approved === true ? "danger" : "success"
                      } mr-2`}
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          `/media/svg/icons/Code/${
                            row.Approved === true
                              ? "Error-circle.svg"
                              : "Done-circle.svg"
                          }`
                        )}
                      />
                    </span>
                    <span className="navi-text">
                      {row.Approved ? "Unapprove" : "Approve"}
                    </span>
                  </a>
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];
  return (
    <>
      <LoadingDialog isLoading={isLoadingAuth} text="Loading ..." />
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {t("Shipper")} | {t("My_Truckers")}
        </title>
      </Helmet>
      <Card>
        <CardHeader title={t("My_Truckers")}>
          <CardHeaderToolbar>
            <button
              className="btn btn-primary mr-5"
              onClick={() => {
                setinitTeamObject({
                  CompanyName: "",
                  McNumber: "",
                  DotNumber: "",
                  Type: "",
                  Address: "",
                  Address2: "",
                  City: "",
                  State: "",
                  Zipcode: "",
                  Country: "",
                  Email: "",
                  PhoneNumber: "",
                  FirstName: "",
                  LastName: "",
                  Website: "",
                });
                setshowAddTruckerModal(true);
              }}
            >
              Add new trucker
            </button>
            <Dropdown>
              <Dropdown.Toggle
                className="mr-5"
                variant="success"
                id="dropdown-basic"
              >
                {t("Export_as")}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    ExportAs(TruckersList || [], "excel", "Truckers");
                  }}
                  href={"#"}
                >
                  <i className="fas fa-file-excel mr-3"></i> Excel
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    ExportAs(TruckersList || [], "csv", "Truckers");
                  }}
                  href="#"
                >
                  <i className="fas fa-file-csv mr-3"></i> Csv
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    ExportAs(TruckersList || [], "json", "Truckers");
                  }}
                  href="#"
                >
                  <i className="fas fa-file mr-3"></i> Json
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="form-group">
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center"
              bootstrap4
              bordered={false}
              keyField="Index"
              pagination={paginationFactory({
                showTotal: true,
                sizePerPage: 10,
                sizePerPageList: [
                  { text: "5", value: 5 },
                  { text: "10", value: 10 },
                  { text: "50", value: 50 },
                ],
              })}
              data={TruckersList || []}
              noDataIndication={
                <h4 style={{ textAlign: "center" }}>
                  {"There is no data available at the moment"}.
                </h4>
              }
              columns={columns}
            ></BootstrapTable>
          </div>
        </CardBody>
      </Card>
      <Modal
        show={showAddTruckerModal}
        size="xl"
        onHide={() => {
          setshowAddTruckerModal(false);
        }}
      >
        <Formik
          enableReinitialize={true}
          initialValues={initTeamObject}
          //validationSchema={ProductEditSchema}
          onSubmit={(values) => {
            if (values.Id) {
              PutTrucker(values);
            } else {
              SaveNewTrucker(values);
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, handleSubmit }) => {
            return (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {values.Id !== undefined ? "Edit trucker" : "Add trucker"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-md-12 row">
                    <div className="col-md-12">
                      <label>Company name</label>
                      <input
                        type="text"
                        placeholder="Company name"
                        className="form-control"
                        name="CompanyName"
                        value={values?.CompanyName}
                        onChange={(e) => {
                          setFieldValue("CompanyName", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>First name</label>
                      <input
                        type="text"
                        placeholder="First name"
                        className="form-control"
                        name="FirstName"
                        value={values?.FirstName}
                        onChange={(e) => {
                          setFieldValue("FirstName", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Last name</label>
                      <input
                        type="text"
                        placeholder="Last name"
                        className="form-control"
                        name="LastName"
                        value={values?.LastName}
                        onChange={(e) => {
                          setFieldValue("LastName", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Phone number</label>
                      <PhoneInput
                        country={"us"}
                        placeholder="(555) 555-5555"
                        value={values?.PhoneNumber}
                        onChange={(phone) => {
                          setFieldValue("PhoneNumber", phone);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Email</label>
                      <input
                        type="text"
                        placeholder="Email"
                        className="form-control"
                        name="Email"
                        value={values?.Email}
                        onChange={(e) => {
                          setFieldValue("Email", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Website</label>
                      <input
                        type="text"
                        placeholder="Website"
                        className="form-control"
                        name="Website"
                        value={values?.Website}
                        onChange={(e) => {
                          setFieldValue("Website", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Type</label>
                      <ReactSelect
                        name="type"
                        id="type"
                        label="type"
                        value={TruckerTypeOptions?.filter(
                          (a) => a.value === values.Type
                        )}
                        options={TruckerTypeOptions}
                        onChange={(e) => {
                          setFieldValue("Type", e !== null ? e.value : "");
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Mc #</label>
                      <input
                        type="text"
                        placeholder="Mc number"
                        className="form-control"
                        name="McNumber"
                        value={values?.McNumber}
                        onChange={(e) => {
                          setFieldValue("McNumber", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Dot #</label>
                      <input
                        type="text"
                        placeholder="Dot number"
                        className="form-control"
                        name="DotNumber"
                        value={values?.DotNumber}
                        onChange={(e) => {
                          setFieldValue("DotNumber", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Address</label>
                      <input
                        type="text"
                        placeholder="Address"
                        className="form-control"
                        name="Address"
                        value={values?.Address}
                        onChange={(e) => {
                          setFieldValue("Address", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Address 2</label>
                      <input
                        type="text"
                        placeholder="Address 2"
                        className="form-control"
                        name="Address2"
                        value={values?.Address2}
                        onChange={(e) => {
                          setFieldValue("Address2", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>Country</label>
                      <ReactSelect
                        onChange={(e) => {
                          setFieldValue("Country", e?.value);
                        }}
                        name="Country"
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={true}
                        isClearable
                        placeholder={`${t("Select")} ${t("Country")}`}
                        options={ContriesViewModel.map((a) => {
                          return {
                            label: a.Name,
                            value: a.Name,
                          };
                        })}
                        value={ContriesViewModel.filter(
                          (a) => a.Name === values?.Country
                        ).map((a) => {
                          return {
                            label: a.Name,
                            value: a.Name,
                          };
                        })}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>State</label>
                      <ReactSelect
                        isSearchable={true}
                        isClearable
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder={`${t("Select")} ${t("State")}`}
                        options={ContriesViewModel?.find(
                          (a) => a.Name === values?.Country
                        )?.States?.map((a) => {
                          return {
                            label: a.Name,
                            value: a.Name,
                          };
                        })}
                        value={ContriesViewModel?.find(
                          (a) => a.Name === values?.Country
                        )
                          ?.States?.filter((a) => a.Name === values?.State)
                          ?.map((a) => {
                            return {
                              label: a.Name,
                              value: a.Name,
                            };
                          })}
                        onChange={(e) => {
                          setFieldValue("State", e?.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-5">
                      <label>City</label>
                      <input
                        type="text"
                        placeholder="City"
                        className="form-control"
                        name="City"
                        value={values?.City}
                        onChange={(e) => {
                          setFieldValue("City", e.target.value);
                        }}
                      />
                    </div>

                    <div className="col-md-6 mt-5">
                      <label>Zipcode</label>
                      <input
                        type="text"
                        placeholder="Zipcode"
                        className="form-control"
                        name="Zipcode"
                        value={values?.Zipcode}
                        onChange={(e) => {
                          setFieldValue("Zipcode", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setshowAddTruckerModal(false);
                    }}
                  >
                    {"Close"}
                  </Button>
                  <Button
                    variant="primary"
                    disabled={isLoadingAuth}
                    onClick={handleSubmit}
                  >
                    {t("Save_Changes")}
                    {isLoadingAuth && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </Button>
                </Modal.Footer>
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
}
